<template>
  <div>
    <elsa-v-datepicker
      class="mt-2"
      v-model="form.month"
      label="Месяц"
      view-format="LLLL yyyy"
      :datepicker-props="{minimumView: 'month'}"
      :clearable="false"
    />
    <elsa-v-select
      class="mt-2"
      v-model="form.device_type"
      html-label="Тип прибора"
      :options="deviceTypes"
    />
  </div>
</template>

<script>
import deviceTypes from "@/dictionaries/deviceTypes";
import formatDate  from "@/client/helpers/formatDate";

export default {
  name:  "ImportFormDevicesValues",
  props: ['data'],
  data() {
    return {
      form:        {
        month:      null,
        deviceType: null,
      },
      deviceTypes: [],
    };
  },
  methods: {
    loadDeviceTypes() {
      deviceTypes.getList().then((list => {
        this.deviceTypes = list.map(item => ({ value: item.id, label: item.name }));
      }));
    },
  },
  mounted() {
    this.loadDeviceTypes();
  },
  watch: {
    'form.month'( value ) {
      this.data.month = formatDate(value, 'yyyy-MM');
    },
    'form.device_type'( value ) {
      this.data.device_type = value ? value.value : null;
    },
  },
};
</script>

<style scoped>

</style>
